// Centralised site constants and content
export const SITE = {
  brand: "Queen Cleopatra",
  tagline: "Legendary Erotic Hypnotist",
  bookingEmbed: {
    widgetId: "5506",
    hash: "Flg4Tk7PYCPxPtMPz30lk2qmEEulYfKhATjcUBukYGDr4hsVeHRz7tOC3DXp",
    scriptSrc: "https://bookme.name/js/booklikeaboss.widget.js",
  },
  external: {
    unlockt: "https://unlockt.me/queencleopatra",
    clips4sale: "https://www.clips4sale.com/studio/queencleopatra",
    iwantclips: "https://iwantclips.com/store/queencleopatra",
  },
  pricing: {
    inPerson: { firstHour: 200, additional: 150 },
    recordingAddon: { firstHour: 150, additional: 100 },
    phone: { thirty: 60, sixty: 100 },
    text: { from: 25 },
  },
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/shop", label: "Shop" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/faq", label: "FAQ" },
  { to: "/blog", label: "Blog" },
  { to: "/appreciation", label: "Appreciation" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "in-person",
    title: "In-Person Session",
    icon: "Sparkles",
    blurb: "Immersive, private face-to-face sessions delivered by a London-based British erotic hypnotist with a crisp English accent. Ideal for deep trance work, bespoke role-play and extended exploration.",
    pricing: "£200 first hour · £150 each additional hour",
    cta: "Book Live",
    calculator: true,
    recordingAvailable: true,
  },
  {
    slug: "fly-on-the-wall",
    title: "Fly-on-the-Wall Video Session",
    icon: "Camera",
    blurb: "Consented, professionally filmed 'fly-on-the-wall' recordings of in-person sessions - available for private purchase or, if agreed, for public sale. Includes production, editing options and usage/release agreement.",
    pricing: "Recording fee £150 first hour · £100 each additional hour (added to session fee)",
    cta: "Request Recording",
    calculator: true,
    recordingAvailable: false,
    recordingMandatory: true,
  },
  {
    slug: "webcam",
    title: "Webcam Session",
    icon: "Monitor",
    blurb: "Full-sensory guidance adapted to webcam; discreet and intimate.",
    pricing: "From £100 per hour",
    cta: "Book Webcam",
    calculator: false,
  },
  {
    slug: "phone",
    title: "Phone Session",
    icon: "Phone",
    blurb: "Intimate voice-led sessions you can experience anywhere.",
    pricing: "£60 / 30 min · £100 / 60 min",
    cta: "Book Phone",
    calculator: false,
  },
  {
    slug: "text",
    title: "Text / Messaging Session",
    icon: "MessageSquare",
    blurb: "Shorter-form interactions via secure messaging for discrete prompts and scheduled micro-sessions.",
    pricing: "From £25 (packages)",
    cta: "Inquire",
    calculator: false,
  },
  {
    slug: "bespoke",
    title: "Bespoke / Packages",
    icon: "Crown",
    blurb: "Custom programmes, ongoing packages and multi-session bundles. Recording and usage agreements apply where relevant.",
    pricing: "By arrangement",
    cta: "Contact for Package",
    calculator: false,
  },
];

// PRODUCTS
// -------------------------------------------------------------
// Each product can optionally have a `url` field pointing to its
// individual Unlockt.me file page. If `url` is not provided, the
// product will fall back to the platform storefront root.
// Update `platform` to "unlockt" and drop the direct file URL in
// `url` as each is uploaded to Unlockt.me.
// -------------------------------------------------------------
export const PRODUCTS = [
  {
    id: "scotts-introduction-to-hypnosis",
    title: "Scott's Introduction to Hypnosis",
    kind: "Fly-on-the-Wall · Recorded Session",
    type: "video",
    duration: "Preview",
    price: "From £9.99",
    description: "An authentic fly-on-the-wall recording of Scott's very first induction. Watch the trance settle in real time - paced, attentive, unrushed.",
    cover: "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/i4rhd52p_Scotts%20Initial%20Induction%20Preview.gif",
    platform: "unlockt",
    url: "",
    pending: true, // Awaiting Unlockt review
  },
  {
    id: "scott-and-the-snake-charmer",
    title: "Scott and the Snake Charmer",
    kind: "Fly-on-the-Wall · Recorded Session",
    type: "video",
    duration: "Feature",
    price: "From £9.99",
    description: "A serpentine descent - slow, coiled focus and a hypnotist's undivided attention. Scott submits, willingly, to the charmer's rhythm.",
    cover: "/nf/hero.jpg",
    platform: "unlockt",
    url: "https://unlockt.me/v/081fbb2f8c",
  },
  {
    id: "scotts-ticklish-voodoo",
    title: "Scott's Ticklish Voodoo",
    kind: "Fly-on-the-Wall · Recorded Session",
    type: "video",
    duration: "Preview",
    price: "From £7.99",
    description: "A playful, consensual fly-on-the-wall recording - laughter as a trance state. Tasteful, light-hearted, beautifully framed.",
    cover: "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/y38xseru_Scott%20tickled%20preview.gif",
    platform: "unlockt",
    url: "https://unlockt.me/v/aae4d4b125",
  },
  {
    id: "crystal-time-with-cleo",
    title: "Crystal Time with Cleo",
    kind: "Recorded Video Session",
    type: "video",
    duration: "Preview",
    price: "From £12.99",
    description: "Eye-contact cues, slow zips and pendulum focus. A close, intimate recorded session captured in real time.",
    cover: "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/hmni9a4o_crystal%20time%20with%20cleo%20preview.gif",
    platform: "unlockt",
    url: "https://unlockt.me/v/93273e8f89",
  },
  {
    id: "crystal-trance-training",
    title: "Crystal Trance Training",
    kind: "Recorded Video Session",
    type: "video",
    duration: "Feature",
    price: "From £12.99",
    description: "Structured, repeatable trance conditioning built around the crystal's focus point. For the returning devotee who wants depth on demand.",
    cover: "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/hmni9a4o_crystal%20time%20with%20cleo%20preview.gif",
    platform: "unlockt",
    url: "https://unlockt.me/v/6534b75101",
  },
  {
    id: "fly-on-the-wall",
    title: "Fly-on-the-Wall - Custom Recording",
    kind: "Custom MP4",
    type: "video",
    duration: "Custom",
    price: "From £150 + session fee",
    description: "A professionally recorded in-person session captured in real time. Delivered as MP4 with agreed usage rights. Recording requires signed Release Agreement.",
    cover: "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/jd8gr8d7_Dolls.jpg",
    platform: "unlockt",
    url: "",
    custom: true,
  },
];

export const FAQS = [
  { q: "Am I susceptible to hypnosis?", a: "Almost everyone can experience some degree of trance. Your willingness, comfort and the rapport between us shape the depth. We always begin with conversation and consent." },
  { q: "Is this safe?", a: "Yes. Every session uses agreed safewords, paced inductions and structured re-orientation. Aftercare is always offered." },
  { q: "How are recordings used?", a: "Only with explicit written consent via a Release Agreement. You choose private-use only, limited distribution or - if and only if you agree - public sale via approved platforms." },
  { q: "How do I prepare?", a: "Be well-rested, lightly fed and hydrated. Avoid alcohol or sedatives. Wear something you feel comfortable and unselfconscious in." },
  { q: "What is your refund policy?", a: "Deposits are non-refundable within 48 hours of appointment. Media purchases via external platforms are governed by the platform's own policies." },
  { q: "How is my privacy protected?", a: "Booking information is held confidentially. We collect only what is required. Payments and media sales are handled by external platforms - no card data is stored on this site." },
];
